import {
  ChangeDetectorRef,
  Component,
  OnInit,
  AfterViewInit,
  ElementRef,
} from '@angular/core';
import { ServiceLocatorService } from '@ncs/ncs-lib';

export interface DahodData {
  region: string;
  totalBlock: number;
  totalSector: number;
  totalCenter: number;  
  openCentersYes: number;
  openCentersNo: number;
  morningMealCount: number;
  morningDishYes: number;
  morningDishNo: number;
  childrenMorningMealYes: number;
  childrenMorningMealNo: number;
  milkPouchCount: number;
  photoofChildrenDrinkingMilkUnderDoodhSanjeevaniSchemeYes: number;
  photoofChildrenDrinkingMilkUnderDoodhSanjeevaniSchemeNo: number;
  afternoonMealCount: number;
  afternoonDishYes: number;
  afternoonDishNo: number;
  afternoonEatYes: number;
  afternoonEatNo: number;
  poshanDish: number;
  photoOfBeneficiariesPresentForTheNutritionEnhancementNo : number;
  photoOfBeneficiariesPresentForTheNutritionEnhancementYes : number;
  preEducationCount: number;
  preEducationYes: number;
  preEducationNo: number;
  qualityOfHotSnacksAndNutritionEnhancedMealsGood: number;
  qualityOfHotSnacksAndNutritionEnhancedMealsAverage: number;
  qualityOfHotSnacksAndNutritionEnhancedMealsBad: number;
}

@Component({
  selector: 'app-dahod-dashboard',
  templateUrl: './dahod-dashboard.component.html',
  styleUrls: ['./dahod-dashboard.component.scss'],
})
export class DahodDashboardComponent implements OnInit, AfterViewInit {
  dahodDataList: any = [];

  constructor(
    public locator: ServiceLocatorService,  
    private cdr: ChangeDetectorRef,
    private el: ElementRef,
  ) {}
   
  // ─────────────────────────────────────────────
  // LIFECYCLE
  // ─────────────────────────────────────────────

  ngOnInit(): void {
    this.tempSelectedArea = 'sector';
    this.getDahodDashboardData();
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.fixSubHeaderTop(), 0);

    // Re-measure on resize (handles rotation + browser zoom)
    window.addEventListener('resize', () => {
      setTimeout(() => this.fixSubHeaderTop(), 100);
    });
  }

  // ─────────────────────────────────────────────
  // FORM STATE
  // ─────────────────────────────────────────────

  form = {
  startDate: this.getTodayDate(),  
  endDate: null,    
    selectedArea: 'sector',
};

getTodayDate(): string {
    return new Date().toISOString().split('T')[0];
}

  tempSelectedArea: string = '';

  onFilter() {
    this.form.selectedArea = this.tempSelectedArea;
    this.getDahodDashboardData();
  }

  // ─────────────────────────────────────────────
  // DATA FETCH
  // ─────────────────────────────────────────────

  getDahodDashboardData() {
    const _self = this;
    this.locator.config
      .getProperty('endpoint.dahodDashboard')
      .then((property: string) => {
        const url = property + '/dashboard';
        _self.locator.http.post(
          url,
          this.form,
          function (res: any, error: boolean) {
          if (error) {
            alert('Server Error: ' + error);
            return;
          }
          _self.dahodDataList = res.result['data'];
            _self.cdr.detectChanges();
            setTimeout(() => _self.fixSubHeaderTop(), 0);
          },
        );
      });
  }

  // ─────────────────────────────────────────────
  // BREAKPOINT HELPER
  // Matches Bootstrap's breakpoints exactly
  // ─────────────────────────────────────────────

  isMobile(): boolean {
    return window.innerWidth < 576; // Bootstrap sm breakpoint
  }

  private getBreakpoint(): 'mobile' | 'tablet' | 'desktop' {
    const w = window.innerWidth;
    if (w < 576) return 'mobile';
    if (w < 768) return 'tablet';
    return 'desktop';
  }

  // ─────────────────────────────────────────────
  // SUB-HEADER STICKY TOP FIX
  // Skipped on mobile — headers are not sticky there
  // ─────────────────────────────────────────────
  
  private fixSubHeaderTop(): void {
    // Removed isMobile() guard — thead is sticky on ALL screen sizes now

    const row1 = this.el.nativeElement.querySelector(
      'thead tr:first-child',
    ) as HTMLElement;
    const headerRow = this.el.nativeElement.querySelector(
      'thead tr.header',
    ) as HTMLElement;
         
    if (row1 && headerRow) {
      const h = row1.offsetHeight;
      headerRow.querySelectorAll('th').forEach((th: Element) => {
        (th as HTMLElement).style.setProperty('top', `${h}px`, 'important');
      });
  }
  }

  // ─────────────────────────────────────────────
  // STICKY COLUMN WIDTHS — per breakpoint per area
  //
  // Only applies on ≥576px (tablet + desktop).
  // On mobile, getStickyStyle() returns {} so CSS
  // position: static takes over — full free scroll.
  //
  // To resize columns: edit numbers here only.
  // ─────────────────────────────────────────────

  private stickyWidths: Record<string, Record<string, number[]>> = {
    desktop: {
      district: [50, 80, 80, 80, 200],
      block: [50, 130, 200, 200],
      sector: [50, 130, 200],
    },
    tablet: {
      district: [40, 70, 70, 70, 160],
      block: [40, 100, 160, 160],
      sector: [40, 100, 160],
    },
};

  // ─────────────────────────────────────────────
  // getStickyStyle()
  // Returns {} on mobile → CSS position:static wins
  // Returns sticky inline styles on tablet/desktop
  // ─────────────────────────────────────────────

  getStickyStyle(idx: number): object {
    // Mobile: return empty — let CSS handle position: static
    if (this.isMobile()) return {};

    const bp = this.getBreakpoint(); // 'tablet' | 'desktop'
  const area = this.form.selectedArea;
    const widths: number[] = this.stickyWidths[bp]?.[area] ?? [50, 130, 200];

  let left = 0;
  for (let i = 0; i < idx; i++) {
      left += widths[i] ?? 50;
  }

    const width = widths[idx] ?? 100;

  return {
    position: 'sticky',
      left: `${left}px`,
      width: `${width}px`,
      'min-width': `${width}px`,
      'max-width': `${width}px`,
    'z-index': 20 - idx,  
  };
}

getStickyCount(): number {
  switch (this.form.selectedArea) {
      case 'district':
        return 5;
      case 'block':
        return 4;
      case 'sector':
        return 3;
      default:
        return 1;
  }
}

  // ─────────────────────────────────────────────
  // TOTALS & PERCENTAGES
  // ─────────────────────────────────────────────

  getTotal(column: keyof DahodData): number {
    return this.dahodDataList.reduce(
      (acc: any, curr: any) => acc + (curr[column] || 0),
      0,
    );
  }

  getPercentageOfCenters(column: keyof DahodData, base: any): string {
    const total = this.getTotal(column);
    if (base === 0) return '0%';
    return ((total / base) * 100).toFixed(2) + '%';
  }

  // ─────────────────────────────────────────────
  // AREA OPTIONS
  // ─────────────────────────────────────────────

  areaOptions = [
    { label: 'જીલ્લો', value: 'district' },
    { label: 'બ્લોક', value: 'block' },
    { label: 'સેજા', value: 'sector' },
  ];

  // ─────────────────────────────────────────────
  // PDF EXPORT
  // ─────────────────────────────────────────────

  public exportPDFData() {
    const _self = this;
    this.locator.config
      .getProperty('endpoint.dahodDashboard')
      .then((property: string) => {
        const keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
        const sid = localStorage.getItem(keySuffix + 'sessionId') || '0';
        const url = property + '/dashboard/pdf;jsessionid=' + sid;
        _self.locator.http
          .getClient()
          .post(url, this.form, { responseType: 'blob' })
          .subscribe(
            (data: any) => _self.downloadDataAsFile(data, 'export.pdf'),
            (err: any) => console.error(err),
          );
      });
  }

  public downloadDataAsFile(data: any, fileName: string) {
    const file = new window.Blob([data], { type: data.type });
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
  }

  getNumberOfDays(): number {
  const start = this.form.startDate;
  const end = this.form.endDate;
  if (start && end) {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const diff = Math.abs(endDate.getTime() - startDate.getTime());
    return Math.floor(diff / (1000 * 60 * 60 * 24)) + 1;
  }
  return 1;
}

getEffectiveBase(fixedBase: number): number {
  return fixedBase * this.getNumberOfDays();
}
}
